import { createSelector } from './selectorWrapper'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { simpleSelectors } from './basicState'
import { Deeplinking } from '../reducers/deeplinking'
import { isMobile, isPhablet } from '../utils/deviceUtils'

export const isCerberusChildSelector = createSelector(
  [simpleSelectors.pageContext],
  (pageContext: WpsRuntime.atv.wps.PageContextModelProps) =>
    pageContext.isCerberusChild
)

export const isDeeplinkableActionReadySelector = createSelector(
  [
    simpleSelectors.pageContext,
    simpleSelectors.deeplinking
  ],
  (
    pageContext: WpsRuntime.atv.wps.PageContextModelProps,
    deeplinking: Deeplinking
  ) =>
    // The deeplinking module is required for deeplinking action specifically on MShop.
    Boolean(pageContext.app !== 'MShop' || deeplinking.ready)
)

// iPads with iPadOS >= 13 are using user agent similar to the MacOS ones.
// See also:
// * https://t.corp.amazon.com/V228832012
// * https://www.scientiamobile.com/detect-ipados-13/
export const isIosMShopSelector = createSelector(
  simpleSelectors.pageContext,
  (pageContext: WpsRuntime.atv.wps.PageContextModelProps) =>
    Boolean(pageContext.app === 'MShop' && (pageContext.os === 'IOS' || pageContext.os === 'MacOS'))
)

export const isMobileSelector = createSelector(
  simpleSelectors.pageContext,
  (pageContext?: WpsRuntime.atv.wps.PageContextModelProps) =>
    isMobile(pageContext)
)

export const isPhabletSelector = createSelector(
    simpleSelectors.pageContext,
    (pageContext?: WpsRuntime.atv.wps.PageContextModelProps) =>
      isPhablet(pageContext)
)

export const isMShopSelector = createSelector(
  simpleSelectors.pageContext,
  (pageContext: WpsRuntime.atv.wps.PageContextModelProps) =>
    pageContext.app === 'MShop'
)

export const isInternetExplorerSelector = createSelector(
  simpleSelectors.pageContext,
  (pageContext: WpsRuntime.atv.wps.PageContextModelProps) =>
    pageContext.app === 'InternetExplorer'
)

export const pageTypeSelector = createSelector(
  simpleSelectors.pageContext,
  (pageContext: WpsRuntime.atv.wps.PageContextModelProps) => pageContext.pageType
)

export const subPageTypeSelector = createSelector(
  simpleSelectors.pageContext,
  (pageContext: WpsRuntime.atv.wps.PageContextModelProps) => pageContext.subPageType
)

export const pageFeaturesSelector = createSelector(
  simpleSelectors.pageContext,
  (pageContext: WpsRuntime.atv.wps.PageContextModelProps) => pageContext.features
)